var React = require('react');

function MapSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.66667 12.4997L6 11.6663M6 11.6663L1 14.1663V3.33301L6 0.833008M6 11.6663V0.833008M6 0.833008L11 3.33301M11 3.33301L16 0.833008V9.16634M11 3.33301V7.49967M13.9167 13.7497L16 15.833M14.3333 12.083C14.3333 13.2336 13.4006 14.1663 12.25 14.1663C11.0994 14.1663 10.1667 13.2336 10.1667 12.083C10.1667 10.9324 11.0994 9.99967 12.25 9.99967C13.4006 9.99967 14.3333 10.9324 14.3333 12.083Z","stroke":"#262AC5","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MapSearch.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = MapSearch;

MapSearch.default = MapSearch;
